module.exports = __webpack_public_path__ + "static/media/glass_closedoor_right.24647293.png";